import { Highlight } from '@/models/Highlight';

export enum HighlightTypes {
    SEND_HIGHLIGHT_REQUEST = '@highlight/SEND_HIGHLIGHT_REQUEST',
    SEND_HIGHLIGHT_SUCCESS = '@highlight/SEND_HIGHLIGHT_SUCCESS',
    SEND_HIGHLIGHT_FAILURE = '@highlight/SEND_HIGHLIGHT_FAILURE',
    HIGHLIGHTS_REQUEST = '@highlight/HIGHLIGHTS_REQUEST',
    HIGHLIGHTS_FAILURE = '@highlight/HIGHLIGHTS_FAILURE',
    HIGHLIGHTS_SUCCESS = '@highlight/HIGHLIGHTS_SUCCESS',
    HIGHLIGHTS_CLEAR = '@highlight/HIGHLIGHTS_CLEAR',
}

export interface HighlightState {
    data: HighlightData;
    loading: boolean;
    hasError: boolean;
}

export interface HighlightData {
    highlightList: Highlight[];
    highlightListSize: number;
}

export interface HighlightsRequest {
    data: HighlightPaginationData;
    resetData?: boolean;
}

export interface HighlightDataResponse {
    listSize: number;
    data: Highlight[];
    resetData?: boolean;
}

export interface HighlightPaginationData {
    offset: number;
    limit: number;
    contentType: string;
    contentId: number;
}
